export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;

export const googleMapApiKey = "AIzaSyA3RHb4mHVKHOqztbusO09M3nMXLS_3Pvo";

export const MAIN_PERMISSION = {
  USER: "user-management",
  BOOKING: "booking-management",
  SUBSCRIPTION: "subscription-management",
  FUEL: "fuel-management",
  FUEL_HISTORY: "fuel-history",
  DISCOUNT: "discount-management",
  PAYMENT: "payment-analytics",
  STAFF: "staff-management",
  ROLE: "role-management",
  CRUD: "crud-management",
  SUPPORT: "support-management",
  CMS: "cms",
};
export const SUB_PERMISSION = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
};

export const permissionRoute = {
  "/": "dashboard",
  "/user-management": "user-management",
  "/staff-management": "staff-management",
  "/booking-management": "booking-management",
  "/subscription-management": "subscription-management",
  "/fuel-management": "fuel-management",
  "/fuel-history": "fuel-history",
  "/discount-management": "discount-management",
  "/payment-analytics": "payment-analytics",
  "/crud-management": "crud-management",
  "/role-management": "role-management",
  "/support-management": "support-management",
  "/cms": "cms",
};

export const notProtectedRoute = [
  "/login",
  "/",
  "/account-settings",
  "/notifications",
];

export const BOOKING_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  CANCELLED: "cancelled",
  AUTO_CANCELLED: "auto-cancelled",
  IN_RIDE: "in-ride",
  ARRIVED: "arrived",
  COMPLETED: "completed",
};

export const USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "system-deactivated",
};
